import e from "../../../utilities/tw.js";
const o = {
  carouselButton: e`absolute top-2/4 hidden size-6 -translate-y-2/4 rounded-full border-0 bg-secondary-active p-5 !outline-none hover:bg-secondary-hover focus-visible:rounded-full focus-visible:border-2 focus-visible:!border-primary-active sm:flex`,
  carouselContainer: e`relative w-full`,
  carouselNextButton: e`left-[-3.75rem]`,
  carouselPrevButton: e`right-[-3.65rem] md:right-[-2.2rem]`,
  carouselSlideContainer: e`w-full p-2 md:w-80`
};
export {
  o as carouselStyles
};
